import React from "react";
import { Drawer, Button, SegmentedControl, NativeSelect, Group, Text, ActionIcon } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';

import { utils, role } from "../../utils/globalVariables";

import InputWrapperCustom from "../../components/general/InputWrapperCustom";

const SUDataUserFilter = ({
    stateShow,
    fnShow,
    stateDefaultFilter,
    stateFilter,
    fnFilter
}) => {
    const { super_user, ...newRole } = role;

    const [data, setData] = React.useState({
        userGender: stateFilter.userGender,
        userLevel: stateFilter.userLevel,
        userSubLevel: stateFilter.userSubLevel,
        userIsActive: stateFilter.userIsActive
    });

    const handleFilter = () => {
        fnFilter(
            data.userGender,
            data.userLevel,
            data.userSubLevel,
            data.userIsActive,
        )
    }

    const handleReset = () => {
        setData(d => ({
            ...d,
            userGender: stateDefaultFilter.userGender,
            userLevel: stateDefaultFilter.userLevel,
            userSubLevel: stateDefaultFilter.userSubLevel,
            userIsActive: stateDefaultFilter.userIsActive,
        }))
    }

    const subLevelList = (stateLevelSlug) => {
        try {
            const subLevelThings = newRole[stateLevelSlug].subLevel;

            const res = Object.keys(subLevelThings).map(subRoleName => ({
                value: subLevelThings[subRoleName].slugSubLevel,
                label: subLevelThings[subRoleName].caption,
            }));

            return res;
        } catch (error) {
            return [];
        }
    }

    return (
        <React.Fragment>
            <Drawer
                opened={stateShow}
                onClose={fnShow}
                withCloseButton={false}
                position="left"
                closeOnClickOutside={true}

                title={
                    <Group noWrap spacing='xs'>
                        <ActionIcon
                            size='lg'
                            variant="light"
                            radius='xl'
                            color="blue"
                            onClick={fnShow}
                        >
                            <IconArrowLeft size='1.25rem' stroke={1.5} />
                        </ActionIcon>

                        <Text>Filter Data</Text>
                    </Group>
                }
                size='md'

                styles={() => ({
                    title: {
                        fontWeight: 'bold',
                        textTransform: 'uppercase'
                    }
                })}
            >
                <InputWrapperCustom
                    stateLabel='Gender'
                    stateWithAsterisk={false}
                    stateError=''
                    stateDescription=''
                    stateMT="1.5rem"
                >
                    <SegmentedControl
                        fullWidth
                        value={data.userGender}
                        onChange={(val) => setData(d => ({ ...d, userGender: val }))}

                        data={[{ value: utils.flagAll, label: 'Semua' }, { value: '1', label: 'Pria' }, { value: '0', label: 'Wanita' }]}
                    />
                </InputWrapperCustom>

                <InputWrapperCustom
                    stateLabel='Jabatan'
                    stateWithAsterisk={false}
                    stateError=''
                    stateDescription=''
                    stateMT="1.5rem"
                >
                    <NativeSelect
                        value={data.userLevel}
                        onChange={(val) => {
                            setData(d => ({
                                ...d,
                                userLevel: val.target.value,
                                userSubLevel: utils.flagAll
                            }));
                        }}

                        data={[
                            { value: utils.flagAll, label: 'Semua' },
                            ...Object.values(newRole).map(key => ({ value: key.slugLevel, label: key.caption })),
                        ]}

                        styles={(tema) => ({
                            input: {
                                backgroundColor: tema.colorScheme === 'light' ? '#fff' : tema.colors.dark[6]
                            }
                        })}
                    />
                </InputWrapperCustom>

                <InputWrapperCustom
                    stateLabel='Sub Jabatan'
                    stateWithAsterisk={false}
                    stateError=''
                    stateDescription=''
                    stateMT="1.5rem"
                >
                    <NativeSelect
                        value={data.userSubLevel}
                        onChange={(val) => setData(d => ({ ...d, userSubLevel: val.target.value }))}

                        data={[
                            { value: utils.flagAll, label: 'Semua' },
                            ...subLevelList(data.userLevel)
                        ]}

                        styles={(tema) => ({
                            input: {
                                backgroundColor: tema.colorScheme === 'light' ? '#fff' : tema.colors.dark[6]
                            }
                        })}
                    />
                </InputWrapperCustom>

                <InputWrapperCustom
                    stateLabel='Status'
                    stateWithAsterisk={false}
                    stateError=''
                    stateDescription=''
                    stateMT="1.5rem"
                >
                    <SegmentedControl
                        fullWidth
                        value={data.userIsActive}
                        onChange={(val) => setData(d => ({ ...d, userIsActive: val }))}

                        data={[{ value: utils.flagAll, label: 'Semua' }, { value: '1', label: 'Aktif' }, { value: '0', label: 'Non Aktif' }]}
                    />
                </InputWrapperCustom>

                <Group noWrap mt='2rem'>
                    <Button
                        fullWidth
                        color="gray"
                        onClick={handleReset}
                    >
                        Reset
                    </Button>

                    <Button
                        fullWidth
                        onClick={handleFilter}
                    >
                        Filter
                    </Button>
                </Group>
            </Drawer>
        </React.Fragment>
    )
}

export default SUDataUserFilter;